/**
 * Javascript for single view of ige_shop.
 * Product Owner: Raphael Wälterlin <raphael.waelterlin@cabag.ch>
 * Author: Markus Gehrig <markus.gehrig@cabag.ch>
 * Date: 15. Apr 2019
 * 
 * Customer: Prospecia Rara
 * Company: cab services ag
 */

/**
 * Load external JavaScript Libaries
 */
var $           = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks    = require('../../../../../../../webpack/node_modules/nunjucks');
var basket      = require("./basket.js");
var translation = require("./translation.js");

var container = ".psr-shop-checkout";

$( document ).ready(function() {
    if ( $( container ).length ) {
        showCheckout();
    }
}); 

function showCheckout() {
    nunjucks.configure('/template/dist/views-shop', {autoescape: true});

    translations = {
        "sumtotal": translation.getTranslation("sumtotal"),
        "price": translation.getTranslation("price"),
        "quantity": translation.getTranslation("quantity"),
        "checkout": translation.getTranslation("checkout"),
        "back": translation.getTranslation("back"),
        "remove": translation.getTranslation("remove"),
        "basket": translation.getTranslation("basket"),
        "highlights": translation.getTranslation("highlights"),
        "order": translation.getTranslation("order"),
        "description": translation.getTranslation("description"),
        "amount": translation.getTranslation("amount"),
        "porto": translation.getTranslation("porto"),
        "portoAdditional": translation.getTranslation("portoAdditional"),
        "article": translation.getTranslation("article"),
        'vat': translation.getTranslation("vat")
    };

    var items = basket.getBasket();

    $('.amount').html(items.numberofproducts);

    var showVat = window.showVat;
    var view = nunjucks.render('checkout.twig', {currency: currency, items: items, translations: translations, showVat: showVat});

    $(container).html(view);

    $(".psr-shop-basket-quantity").change( function() {
        basket.changeQuantity( $(this).data('uid'), parseInt($(this).val()) );
        showCheckout();
    });

    $('.psr-shop-basket-remove').click(function() {
        basket.remove($(this).data('uid'));
        showCheckout();
    });
}
